import UserManagementSchoolQuiz from "../../../School-Quiz-Mgt-admin/pages/UserManagement";
import SchoolSelect from "./SchoolSelect";

export default function QuizzesStudent() {
  return (
    <div className="container-fluid px-5 py-3">
      {/* <div className="mb-4 d-flex align-items-center">
        <div>
          <button
            className={`btn me-2 ${
              studentType === "individual"
                ? "btn-success"
                : "btn-outline-success"
            }`}
            onClick={() => setStudentType("individual")}
          >
            Individual Students
          </button>
          <button
            className={`btn ${
              studentType === "school" ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => setStudentType("school")}
          >
            School Students
          </button>
        </div>
      </div> */}
       <UserManagementSchoolQuiz />
      {/* {studentType === "school" && <SchoolSelect />} */}
    </div>
  );
}
